/**
 * @fileoverview GET handler for the "/engagement/campaigns/global_rate_limits/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsGlobalRateLimitsAppGroupId } from "./constants";
import type { EngagementCampaignsGlobalRateLimitsAppGroupIdResult } from "./types";
import { isEngagementCampaignsGlobalRateLimitsAppGroupIdResult } from "./validators";

export const getEngagementCampaignsGlobalRateLimitsAppGroupId = reactQueryFetcherAdapter(
  engagementCampaignsGlobalRateLimitsAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementCampaignsGlobalRateLimitsAppGroupIdResult[]> => {
    return fetch(`/engagement/campaigns/global_rate_limits/${appGroupId}`, "GET", {}, { signal });
  },
  isEngagementCampaignsGlobalRateLimitsAppGroupIdResult
);
